import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class UserRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getContactToken() {
    throw new Error('[UserRepository#getContactToken] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getUser() {
    throw new Error('[UserRepository#getUser] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getCurrentUser() {
    throw new Error('[UserRepository#getCurrentUser] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  updateCurrentUser() {
    throw new Error('[UserRepository#updateCurrentUser] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  updateUser() {
    throw new Error('[updateUser#getCurrentUser] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getUserTakeoutLink() {
    throw new Error('[UserRepository#getUserTakeoutLink] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getUserTakeoutList() {
    throw new Error('[UserRepository#getUserTakeoutList] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  contactByMailAsLoggedUser() {
    throw new Error('[UserRepository#contactByMailAsLoggedUser] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  contactByMailAsNotLoggedUser() {
    throw new Error('[UserRepository#contactByMailAsNotLoggedUser] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  saveContactToken() {
    throw new Error('[UserRepository#getContactToken] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getBuyerIntentions() {
    throw new Error('[UserRepository#getBuyerIntentions] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  createWhatsappIntents() {
    throw new Error('[UserRepository#createWhatsappIntents] must be implemented')
  }

  setAuthenticationToken() {
    throw new Error('[UserRepository#setAuthenticationToken] must be implemented')
  }

  setToken() {
    throw new Error('[UserRepository#setToken] must be implemented')
  }
}
